import { Button, breakpoints, TableRow, TableHeadCell, pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const LoaderContainer = styled.div `
  margin: ${theme.spacing.xl} 0;
  display: flex;
  justify-content: center;
`;
export const TooltipButton = styled(Button) `
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  color: ${theme.semantic.foreground.tertiary};
  margin-right: ${theme.spacing.xl};
`;
export const PaginationContainer = styled.div `
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;

  ${breakpoints.md} {
    justify-content: flex-start;
  }
`;
export const HiddenTableRow = styled(TableRow) `
  height: 0 !important;
`;
export const HiddenTableHeadCell = styled(TableHeadCell) `
  border: none !important;
`;
